import React from "react";
import { ArrowDown } from "lucide-react";

// Petit lien de navigation secondaire : défile vers la section générale
// « Préparer votre rendez-vous » (id="preparer-rdv"), présente en bas de page.
export const ASavoir = ({ className = "" }) => (
  <button
    type="button"
    data-testid="a-savoir-link"
    onClick={() =>
      document
        .getElementById("preparer-rdv")
        ?.scrollIntoView({ behavior: "smooth", block: "start" })
    }
    className={`group inline-flex items-center gap-2 text-[13px] font-medium tracking-[0.2em] uppercase text-[#944639] underline decoration-[#b07a63]/60 underline-offset-4 hover:text-[#4b2018] transition-colors ${className}`}
  >
    À savoir
    <ArrowDown
      size={14}
      className="transition-transform duration-300 group-hover:translate-y-0.5"
    />
  </button>
);
